import { Translate } from '../../../shared/LanguageService';

export type NewsFeedLabels = {
    newsTitle: string;
    noNews: string;
    newItem: string;
    notificationTooltip: string;
    notificationTooltipSingular: string;
    closeTooltip: string;
    readMore: string;
    showLess: string;
};

export type NewsArticleLabels = Pick<NewsFeedLabels, 'newItem' | 'readMore' | 'showLess'>;

export function translateNewsFeedLabels(): NewsFeedLabels {
    return {
        newsTitle: Translate('header/nav/news-component/title'),
        noNews: Translate('header/nav/news-component/no-news'),
        newItem: Translate('header/nav/news-component/new-item'),
        notificationTooltip: Translate('header/nav/news-component/notification-tooltip'),
        notificationTooltipSingular: Translate(
            'header/nav/news-component/notification-tooltip-singular'
        ),
        closeTooltip: Translate('header/nav/news-component/close-tooltip'),
        readMore: Translate('header/nav/news-component/read-more'),
        showLess: Translate('header/nav/news-component/show-less')
    };
}
